import React from 'react';
import { Card, CardContent, Typography, Grid } from '@mui/material';
import { Doughnut, Bar, Pie } from 'react-chartjs-2';


const Dashboard = ({ cvs }) => {
  // Extracting data for charts
  const occupationData = {};
  const ageData = {};

  cvs.forEach(cv => {
    // Counting occupation occurrences
    const occupation = cv.extraField.occupation;
    occupationData[occupation] = (occupationData[occupation] || 0) + 1;

    // Calculating age from dob
    const dob = new Date(cv.Employee.dob);
    const age = new Date().getFullYear() - dob.getFullYear();
    const ageRange = `${Math.floor(age / 10) * 10}-${Math.floor(age / 10) * 10 + 9}`;
    ageData[ageRange] = (ageData[ageRange] || 0) + 1;
  });

  // Sorting ageData keys (age ranges) in ascending order
  const sortedAgeData = Object.keys(ageData)
    .sort((a, b) => parseInt(a) - parseInt(b))
    .reduce((obj, key) => {
      obj[key] = ageData[key];
      return obj;
    }, {});

  // Last day, last 7 days, last 30 days count
  const today = new Date();
  const lastDayCount = cvs.filter(cv => {
    const createdAt = new Date(cv.createdAt);
    const diffInDays = (today - createdAt) / (1000 * 60 * 60 * 24);
    return diffInDays <= 1;
  }).length;

  const last7DaysCount = cvs.filter(cv => {
    const createdAt = new Date(cv.createdAt);
    const diffInDays = (today - createdAt) / (1000 * 60 * 60 * 24);
    return diffInDays <= 7;
  }).length;

  const last30DaysCount = cvs.filter(cv => {
    const createdAt = new Date(cv.createdAt);
    const diffInDays = (today - createdAt) / (1000 * 60 * 60 * 24);
    return diffInDays <= 30;
  }).length;

  const occupationChartOptions = {
    maintainAspectRatio: true,
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
      },
    },
  };

  const ageChartOptions = {
    maintainAspectRatio: true,
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
    },
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">CVs created last day</Typography>
            <Typography variant="h3">{lastDayCount}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">CVs created last 7 days</Typography>
            <Typography variant="h3">{last7DaysCount}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">CVs created last 30 days</Typography>
            <Typography variant="h3">{last30DaysCount}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Card style={{
            height:550
        }}>
          <CardContent>
            <Typography variant="h6">Occupation Distribution</Typography>
            <Bar  data={{ labels: Object.keys(occupationData), datasets: [{ data: Object.values(occupationData), backgroundColor: ['red', 'blue', 'green','pink','purple','yellow'] }] }} options={occupationChartOptions} />
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );
};

export default Dashboard;
